export default __webpack_public_path__ + "static/media/qr-code.c149727a.svg";